module.exports = __webpack_public_path__ + "img/100c48b.webp";